import { Component, Input } from '@angular/core';

@Component({
  selector: 'core-loader',
  templateUrl: 'loader.component.html',
  styleUrls: ['./loader.component.css'],
})
export class LoaderComponent {
  @Input()
  public loading: boolean;
  @Input()
  public error = false;
}
